import type { Typographies } from "@superblocksteam/shared";
export const DEFAULT_RTE_WIDGET_LABEL_TEXT_STYLE_VARIANT: keyof Typographies =
  "inputLabel";
